import React, { useEffect, useState } from 'react';
import HeaderContent from 'components/common/HeaderContent/HeaderContent';
import { Form, Radio, Typography } from 'antd';
import SelectCommon from 'components/common/Select/SelectCommon';
import { formatPrice, roundMoney } from 'utils';
import { InputCommon } from 'components/common/Input/InputCommon';
import { ButtonCommon } from 'components/common/Button/ButtonCommon';
import ModalConfirmPayment from 'components/common/Modal/ModalConfirmPayment';
import ModalListCart from 'components/common/Modal/ModalListCart';
import { PaymentType } from 'models';
import { ChoicePaymentProps } from 'types';
import { Bank, Money } from '@phosphor-icons/react';
// import { useNavigate } from 'react-router-dom';
import { TransactionMethodCode } from 'models/TransactionMethod';
const { Text } = Typography;

const vatOptions = [
  { label: '0%', value: 0 },
  { label: '5%', value: 5 },
  { label: '8%', value: 8 },
  { label: '10%', value: 10 },
  { label: '12%', value: 12 },
];
const modalTexts = {
  [PaymentType.FULL_PAYMENT]: {
    headerLabel: 'Xác nhận thanh toán',
    headerContent: 'Vui lòng làm theo các bước dưới đây',
    saveButtonLabel: 'Tải lên chứng từ',
  },
  [PaymentType.PARTIAL_PAYMENT_FIXED]: {
    headerLabel: 'Xác nhận thanh toán 15%',
    headerContent: 'Vui lòng làm theo các bước dưới đây',
    saveButtonLabel: 'Tải lên chứng từ',
  },
  [PaymentType.PARTIAL_PAYMENT_FLEX]: {
    headerLabel: 'Xác nhận thanh toán tùy chọn',
    headerContent: 'Vui lòng làm theo các bước dưới đây',
    saveButtonLabel: 'Tải lên chứng từ',
  },
  [PaymentType.NEGOTIATED_PAYMENT]: {
    headerLabel: 'Xác nhận thông tin sản phẩm',
    headerContent: 'Vui lòng làm theo các bước dưới đây để xác nhận thông tin sản phẩm',
    saveButtonLabel: 'Xác nhận tạo đơn hàng',
  },
};

const ChoicePayment: React.FC<ChoicePaymentProps> = ({
  form,
  subTotal,
  totalQuantity,
  cartList,
  defaultMethod,
  labelHeader,
  backgroundHeader = 'white',
  classname = 'bg-white',
  defaultCouple,
  // defaultVat,
  customAmount,
  setCustomAmount,
  onSubmit,
  // onConfirmPayment,
  isRead = false,
  selectedMethod,
  setSelectedMethod,
  isLoading,
  statusDefault,
  selectedVAT = 0,
  setSelectedVAT = () => {},
  handleUploadExcel,
}) => {
  const [openConfirm, setOpenConfirm] = useState(false);
  const [couple, setCouple] = useState<string>(defaultCouple || '');
  const [openShowCart, setOpenShowCart] = useState<boolean>(false);
  const [transactionMethod, setTransactionMethod] = useState<TransactionMethodCode>('CASH');
  // const navigate = useNavigate();
  const handleSubmit = () => {
    const { total } = calculateAmounts();
    localStorage.setItem('countPageBack', '2');
    if (onSubmit) {
      onSubmit(roundMoney(total), transactionMethod, selectedMethod, 2);
    }
  };
  const calculateAmounts = () => {
    const discount = 0;
    const total = Number(subTotal) + (selectedVAT / 100) * Number(subTotal) - discount;
    let prepaid = 0;
    switch (selectedMethod) {
      case PaymentType.FULL_PAYMENT:
        prepaid = total;
        break;
      case PaymentType.PARTIAL_PAYMENT_FIXED:
        prepaid = total * (15 / 100);
        break;
      case PaymentType.PARTIAL_PAYMENT_FLEX:
        prepaid = 0;
        break;
      case PaymentType.NEGOTIATED_PAYMENT:
        prepaid = 0;
        break;
    }
    let remaining = total - prepaid;
    if (prepaid > total) {
      remaining = 0;
    }
    return {
      total,
      prepaid,
      remaining,
    };
  };
  const { total, prepaid } = calculateAmounts();
  useEffect(() => {
    if (setCustomAmount) {
      setCustomAmount(prepaid);
    }

    form.setFieldValue('customAmout', prepaid);
  }, [prepaid]);
  const isDisabled = () => {
    if (selectedMethod === PaymentType.PARTIAL_PAYMENT_FLEX) {
      return customAmount > subTotal;
    }
  };
  return (
    <div className={`w-[444px] h-full rounded-lg border border-[var(--textBlack8)]  ${classname} `}>
      <HeaderContent
        key='cartSupplier'
        size='sm'
        label={labelHeader || `PHƯƠNG THỨC THANH TOÁN`}
        className={`rounded-none shadow-none`}
        background={backgroundHeader}
      />

      <Form form={form} className='flex flex-col gap-6 px-6 py-3 max-h-[calc(100%-64px)] h-full'>
        {defaultMethod ? (
          <div className=' px-6 py-3 rounded-2xl border cursor-default border-[var(--primaryColor500)]'>
            <p className='font-bold'>
              {defaultMethod === PaymentType.FULL_PAYMENT && 'Thanh toán toàn bộ'}
              {defaultMethod === PaymentType.PARTIAL_PAYMENT_FIXED && 'Thanh toán tối thiểu 15%'}
              {defaultMethod === PaymentType.PARTIAL_PAYMENT_FLEX && 'Thanh toán số tiền khác tùy chọn'}
              {defaultMethod === PaymentType.NEGOTIATED_PAYMENT && 'Đặt hàng không cần thanh toán'}
            </p>
            <p className='mt-1 h-5'>
              <Text className='text-[var(--textBlack56)]'>
                {defaultMethod === PaymentType.FULL_PAYMENT && 'Thanh toán tổng số tiền của tất cả sản phẩm'}
                {defaultMethod === PaymentType.PARTIAL_PAYMENT_FIXED &&
                  'Thanh toán tối thiểu 15% tổng giá trị đơn hàng'}
                {defaultMethod === PaymentType.PARTIAL_PAYMENT_FLEX && 'Bạn có thể thanh toán số tiền tùy ý'}
                {defaultMethod === PaymentType.NEGOTIATED_PAYMENT && 'Thanh toán số tiền tùy chọn với nhà cung cấp'}
              </Text>
            </p>
          </div>
        ) : (
          <Radio.Group
            buttonStyle='solid'
            value={selectedMethod}
            onChange={(e) => setSelectedMethod(e.target.value)}
            className='w-full flex flex-col gap-3'
          >
            <div
              className={` px-6 py-3 rounded-2xl border cursor-pointer ${
                selectedMethod === PaymentType.FULL_PAYMENT ? ' border-[var(--primaryColor500)]' : ''
              }`}
              onClick={() => setSelectedMethod(PaymentType.FULL_PAYMENT)}
            >
              <Radio value={PaymentType.FULL_PAYMENT} className='custom-radio'>
                Thanh toán toàn bộ
              </Radio>
              <p className='pl-6 mt-1 min-h-5'>
                <Text className='text-[var(--textBlack56)]'>Thanh toán tổng số tiền của tất cả sản phẩm</Text>
              </p>
            </div>

            {/* <div
              className={` px-6 py-3 rounded-2xl border cursor-pointer ${
                selectedMethod === PaymentType.PARTIAL_PAYMENT_FIXED ? 'border border-[var(--primaryColor500)]' : ''
              }`}
              onClick={() => setSelectedMethod(PaymentType.PARTIAL_PAYMENT_FIXED)}
            >
              <Radio value={PaymentType.PARTIAL_PAYMENT_FIXED} className='custom-radio'>
                Thanh toán tối thiểu 15%
              </Radio>
              <p className='pl-6 mt-1 h-5'>
                <Text className='text-[var(--textBlack56)]'>Thanh toán tối thiểu 15% tổng giá trị đơn hàng</Text>
              </p>
            </div> */}

            <div
              className={` px-6 py-3 rounded-2xl border cursor-pointer ${
                selectedMethod === PaymentType.PARTIAL_PAYMENT_FLEX ? 'border border-[var(--primaryColor500)]' : ''
              }`}
              onClick={() => setSelectedMethod(PaymentType.PARTIAL_PAYMENT_FLEX)}
            >
              <Radio value={PaymentType.PARTIAL_PAYMENT_FLEX} className='custom-radio'>
                Thanh toán số tiền khác tùy chọn
              </Radio>
              <p className='pl-6 mt-1 min-h-5'>
                <Text className='text-[var(--textBlack56)]'>Bạn có thể thanh toán số tiền tùy ý</Text>
              </p>
            </div>

            {/* <div
              className={`px-6 py-3 rounded-2xl border cursor-pointer ${
                selectedMethod === PaymentType.NEGOTIATED_PAYMENT ? 'border border-[var(--primaryColor500)]' : ''
              }`}
              onClick={() => setSelectedMethod(PaymentType.NEGOTIATED_PAYMENT)}
            >
              <Radio value={PaymentType.NEGOTIATED_PAYMENT} className='custom-radio'>
                Đặt hàng không cần thanh toán
              </Radio>
              <p className='pl-6 mt-1 h-5'>
                <Text className='text-[var(--textBlack56)]'>Thanh toán số tiền tùy chọn với nhà cung cấp</Text>
              </p>
            </div> */}
          </Radio.Group>
        )}
        <div className='flex flex-col gap-2 flex-1'>
          <div className='flex items-center h-8 gap-2'>
            <p className='min-w-[120px] text-[var(--textBlack56)]'>Số lượng</p>
            <span className='text-black'>{totalQuantity}</span>
            <span className='text-[var(--textBlack56)] font-medium'>sản phẩm</span>
            <p className='text-[var(--primaryColor500)] font-bold cursor-pointer' onClick={() => setOpenShowCart(true)}>
              Xem nhanh
            </p>
          </div>
          <div className='flex items-center h-8 gap-2'>
            <p className='min-w-[120px] text-[var(--textBlack56)]'>Tạm tính</p>
            <span className='text-black font-bold'>{formatPrice(subTotal ?? 0)}</span>
            <span className='text-[var(--textBlack56)] font-bold'>VND</span>
          </div>
          <div className='flex items-center h-10 gap-2'>
            <p className='min-w-[120px] text-[var(--textBlack56)]'>VAT</p>
            {isRead ? (
              <span>{selectedVAT}%</span>
            ) : (
              <SelectCommon
                placeholderSelect='Chọn VAT'
                options={vatOptions}
                value={selectedVAT}
                onChange={(value) => setSelectedVAT(value)}
                labelRender={() => {
                  const selected = vatOptions.find((opt) => opt.value === selectedVAT);
                  const vatAmount = (selectedVAT / 100) * subTotal;
                  return `${selected?.label} ~ ${formatPrice(vatAmount)} VND`;
                }}
              />
            )}
          </div>
          <div className='border-t border-t-[var(--bgBlackOpacity)]'></div>
          <div className='flex items-center h-10 gap-2'>
            <p className='min-w-[120px] text-black'>Mã giảm giá</p>
            {isRead ? (
              <span>{couple}</span>
            ) : (
              <InputCommon
                className='!px-3 bg-transparent'
                value={couple}
                placeholder='Nhập vào mã giảm giá'
                onChange={(e) => setCouple(e.target.value)}
              />
            )}
          </div>
          <div className='flex items-center h-8 gap-2'>
            <p className='min-w-[120px] text-black font-bold text-base'>Tổng tiền</p>
            <span className='text-[var(--primaryColor500)] font-bold text-base'>{formatPrice(total ?? 0)}</span>
            <span className='text-[var(--primaryColor300)] font-bold'>VND</span>
          </div>
          <Form.Item name={'totalPrice'} hidden initialValue={total} />
          {selectedMethod !== PaymentType.FULL_PAYMENT && (
            <>
              {selectedMethod !== PaymentType.NEGOTIATED_PAYMENT ? (
                <>
                  <div className='flex items-center gap-2'>
                    <p className='min-w-[120px] text-black font-bold text-base'>
                      Trả trước {selectedMethod === PaymentType.PARTIAL_PAYMENT_FLEX ? '' : '15%'}
                    </p>
                    {selectedMethod === PaymentType.PARTIAL_PAYMENT_FLEX && !defaultMethod ? (
                      <Form.Item name={'customAmout'} className='!mb-0 w-full'>
                        <InputCommon
                          className='!px-3'
                          placeholder='Nhập vào số tiền tùy chỉnh'
                          type='money'
                          value={Number(customAmount) || prepaid}
                          min={0}
                          max={total}
                          onChange={(e) => {
                            if (setCustomAmount) {
                              setCustomAmount(Number(e.target.value));
                            }
                          }}
                        />
                      </Form.Item>
                    ) : (
                      <>
                        <span className='text-[var(--primaryColor500)] font-bold text-base'>
                          {formatPrice(customAmount)}
                        </span>
                        <span className='text-[var(--primaryColor300)] font-bold'>VND</span>
                      </>
                    )}
                  </div>
                  <div className='flex items-center h-8 gap-2'>
                    <p className='min-w-[120px] text-[var(--textBlack56)] '>Còn lại</p>
                    <span className='text-black font-bold'>{formatPrice(total - customAmount)}</span>
                    <span className='text-[var(--textBlack56)] font-bold'>VND</span>
                  </div>
                </>
              ) : (
                <>
                  <p className='text-[var(--textBlack56)] h-[68px]'>
                    Số tiền này được thanh toán khi nhận hàng hoặc theo bàn bạc của 2 bên{' '}
                  </p>
                </>
              )}
            </>
          )}
        </div>
        {statusDefault ? (
          <>
            {/* {statusDefault !== StatusOrderSupplierCode.PAID &&
            statusDefault !== StatusOrderSupplierCode.PAYMENT_DEFERRENCE &&
            statusDefault !== StatusOrderSupplierCode.WAIT_PAYMENT ? (
              <>
                <ButtonCommon
                  color='none'
                  size='md'
                  radius='rounded'
                  className={` ${isDisabled() ? 'bg-[var(--primaryColor300)]' : 'bg-[var(--primaryColor500)]'} flex justify-center px-3 !py-3 text-white !-mt-2 font-bold hover:bg-[var(--primaryColor300)] `}
                  iconPosition='right'
                  disabled={isDisabled()}
                  onClick={onConfirmPayment}
                >
                  <p>Xác nhận đã thanh toán đơn hàng</p>
                </ButtonCommon>
              </>
            ) : (
              <ButtonCommon
                color='none'
                size='md'
                radius='rounded'
                className={`bg-[var(--bgBlackOpacity)] text-black hover:font-normal px-3 !py-3`}
                iconPosition='right'
                disabled={isDisabled()}
                onClick={() => {
                  navigate('/management/inventory/supplier-orders');
                }}
                icon={<ArrowUUpLeft size={20} />}
              >
                <p>Quay về trang quản lý đơn hàng</p>
              </ButtonCommon>
            )} */}
          </>
        ) : (
          <div className='w-full flex flex-col gap-2'>
            <div className='flex gap-3 mb-3'>
              <ButtonCommon
                color={transactionMethod === 'CASH' ? 'primary' : 'soft'}
                radius='rounded'
                className='!w-[50%] h-10'
                onClick={() => setTransactionMethod('CASH')}
                icon={<Money size={20} />}
              >
                Tiền mặt
              </ButtonCommon>

              <ButtonCommon
                color={transactionMethod === 'BANK_TRANSFER' ? 'primary' : 'soft'}
                radius='rounded'
                className='!w-[50%] h-10'
                onClick={() => setTransactionMethod('BANK_TRANSFER')}
                icon={<Bank size={20} />}
              >
                Chuyển khoản
              </ButtonCommon>
            </div>
            <ButtonCommon
              color={'primary'}
              size='md'
              radius='rounded'
              className={` justify-between font-bold`}
              iconPosition='right'
              disabled={isDisabled()}
              onClick={() => {
                form
                  .validateFields()
                  .then(() => {
                    setOpenConfirm(true);
                  })
                  .catch((error) => {
                    console.error('Validation failed:', error);
                  });
              }}
            >
              {selectedMethod === PaymentType.NEGOTIATED_PAYMENT ? (
                <p>Hoàn tất đơn hàng</p>
              ) : (
                <>
                  <p>Thanh toán</p>
                  <p>
                    {formatPrice(customAmount)} <span className='ml-2 font-normal'>VND</span>
                  </p>
                </>
              )}
            </ButtonCommon>
          </div>
        )}
      </Form>
      <ModalConfirmPayment
        form={form}
        open={openConfirm}
        saveButtonLabel={modalTexts[selectedMethod].saveButtonLabel}
        onClose={() => setOpenConfirm(false)}
        headerLabel={modalTexts[selectedMethod].headerLabel}
        headerContent={modalTexts[selectedMethod].headerContent}
        onSubmit={handleSubmit}
        isLoading={isLoading}
        handleUploadExcel={handleUploadExcel}
      />

      <ModalListCart openShowCart={openShowCart} onClose={() => setOpenShowCart(false)} cartList={cartList} />
    </div>
  );
};

export default ChoicePayment;
